
import { googleMapsDefaults } from '@/constants';
import { Location } from '@/types/shared';
import { computed, defineComponent, PropType } from 'vue';

export default defineComponent({
  name: 'LocationCell',
  props: {
    location: {
      type: Object as PropType<Location>,
      required: true
    }
  },
  setup(props) {
    const text = computed(() => {
      if (props.location.address) {
        return props.location.address;
      }

      return `${props.location.geoPoint?.latitude.toFixed(
        googleMapsDefaults.latLngPrecision
      )}, ${props.location.geoPoint?.longitude.toFixed(googleMapsDefaults.latLngPrecision)}`;
    });

    return {
      text
    };
  }
});
